import type { ApolloError } from '@apollo/client'
import type { ReactNode } from 'react'

type ToErrorNode = (apolloError?: ApolloError) => ReactNode

interface ErrorNodeConfig extends Record<string, ToErrorNode> {
  fallback: ToErrorNode
}

const defaultErrorNodeConfig: ErrorNodeConfig = {
  fallback: _ => 'An unexpected error occurred',
}

const toErrorNodeConfig = (customErrorNodeConfig?: ErrorNodeConfig): ErrorNodeConfig => ({
  ...customErrorNodeConfig,
  ...defaultErrorNodeConfig,
})

export const toErrorNode = (
  error?: ApolloError,
  customErrorNodeConfig = defaultErrorNodeConfig,
): ReactNode => {
  const errorName = error?.name
  const errorNodeConfig = toErrorNodeConfig(customErrorNodeConfig)

  if (errorName === undefined) {
    return
  }

  if (!errorNodeConfig.hasOwnProperty(errorName)) {
    return errorNodeConfig.fallback(error)
  }

  return errorNodeConfig[errorName](error)
}
